// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KH91","col":"styles_col__3-qB8"};